angular.module('cloudX').directive('editableCkeditor', [
  'editableDirectiveFactory',
  '$timeout',
  function(editableDirectiveFactory, $timeout) {
    var dir = editableDirectiveFactory({
      directiveName: 'editableCkeditor',
      inputTpl:
        '<cx-ckeditor key="{{key}}" name={{name}} placeholder={{placeholder}}></cx-enum-picker>',
      render: function() {
        this.parent.render.call(this);
        if (this.scope.$data) {
          this.scope.$data = this.convertNewlinesTextToRichText(this.scope.$data);
        }
        if (this.attrs.eFormclass) {
          this.editorEl.addClass(this.attrs.eFormclass);
          this.inputEl.removeAttr('formclass');
        }
      },
      convertNewlinesTextToRichText: function(content) {
        if (content && typeof content === 'string' && !content.includes('<html')) {
          return content.replace(/(?:\r\n|\r|\n)/g, '<br />');
        }
        return content;
      },
      addListeners: function() {
        var self = this;
        self.parent.addListeners.call(self);
        // submit textarea by ctrl+enter even with buttons
        if (self.single && self.buttons !== 'no') {
          self.autosubmit();
        }
      },
      autosubmit: function() {
        var self = this;

        self.editorEl.on('keyup', function(e) {
          if (self.attrs.submitOnEnter) {
            if (e.keyCode === 13 && !e.shiftKey) {
              self.scope.$apply(function() {
                self.scope.$form.$submit();
              });
            }
          } else if (
            ((e.ctrlKey || e.metaKey) && e.keyCode === 13) ||
            (e.keyCode === 9 && self.editorEl.attr('blur') === 'submit')
          ) {
            self.scope.$apply(function() {
              self.scope.$form.$submit();
            });
          }
        });
      },
    });
    return dir;
  },
]);
